<template>

    <div class="max-width-md-large m-auto">
        <div class="card card--large card--green mb-3">
            <h3 class="mb-3 sm-mb-2 text-center">Thank you!</h3>
            <div class="fs-20 lh-13 sm-fs-18">
                <div class="fw-light mb-3 sm-mb-2">Thank you for your <span class="fw-bold">{{ type }}</span> donation of <span class="fw-bold">{{ amount | currency }}</span> to <span class="fw-bold">{{ title }}</span>
                    <template v-if="aidAmount">, of which we can claim an extra <span class="fw-bold">{{ aidAmount | currency }}</span> Gift Aid.</template>
                    <template v-else>.</template>
                </div>

                <div class="fw-light mb-3 sm-mb-2">With the generosity of our supporters we can continue to give people with learning disabilities work skills and employment opportunities.</div>

                <div class="fw-light">Please share your giving experience today and spread the word to others who may be able to help us in our work.</div>

                <div class="d-flex w-100 mt-4 justify-content-center">
                    <add-this-share></add-this-share>
                </div>

            </div>
        </div>
    </div>

</template>

<script>

    import AddThisShare from "../addthis-share/AddThisShare";
    import Cookies from "js-cookie";

    export default {
        name: 'DonationPaymentSuccess',
        components: {AddThisShare},
        comments: {
            AddThisShare
        },
        props: {
            type: {
                type: String,
                required: true,
            },
            amount: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            payment: {
                type: Object,
                required: true
            }
        },

        computed: {
            aidAmount() {
                return (
                    this.payment.hasOwnProperty('gift_aid_amount') &&
                    this.payment.gift_aid_amount
                ) ? this.payment.gift_aid_amount : false;
            }
        },
        methods: {

            getFormData() {
                return new Promise(resolve => {
                    this.meta = JSON.parse(Cookies.get(this.formData));
                    return resolve();
                });
            },

        },
        mounted() {
            this.getFormData().then(()=>{
                Cookies.remove('formData');
            }).catch((error)=>{
                this.error = error.response.data.message;
            });
        },
    }

</script>
